import { axios, baseURL } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDebtorStatements(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/debtor_statements', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDebtorStatement(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/debtor_statements/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDetailBreakdown(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/debtor_statements/${params.id}/detail_breakdown`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    printOutstanding(ctx, params) {
      return new Promise((resolve, reject) => {
        fetch(`${baseURL}/api/v1/debtor_statements/${params.id}/outstanding.xlsx`, {
          method: "GET",
          headers: Object.assign($cookies.get("userAuth"), { "Access-Control-Allow-Origin": "*" })
        })
          .then((response) => {
            resolve(response.blob());
          })
          .catch((error) => reject(error));
      });
    },
    fetchDebtorAgings(ctx, params) {
      return new Promise((resolve, reject) => {
        const urlParams = new URLSearchParams()
        urlParams.append('month_end', params.month_end)
        fetch(`${baseURL}/api/v1/debtor_statements/debtor_agings.xlsx?${urlParams}`, {
          method: "GET",
          headers: Object.assign($cookies.get("userAuth"), { "Access-Control-Allow-Origin": "*" })
        })
          .then((response) => {
            resolve(response.blob());
          })
          .catch((error) => reject(error));
      });
    },
  }
}